import { render, staticRenderFns } from "./FaqsLandingPage.vue?vue&type=template&id=6276935c&scoped=true"
import script from "./FaqsLandingPage.vue?vue&type=script&lang=js"
export * from "./FaqsLandingPage.vue?vue&type=script&lang=js"
import style0 from "./FaqsLandingPage.vue?vue&type=style&index=0&id=6276935c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6276935c",
  null
  
)

export default component.exports